export interface CatalogItem {
    id: number;
    name: string;
}

export interface Municipality extends CatalogItem {
    code?: string;
}

export interface Third {
    id?: number;
    usersId?: number;
    name: string;
    email: string;
    phone: string;
    identification: string;
    identificationsId: number;

    // Roles
    client?: boolean | number;
    provider?: boolean | number;
    other?: boolean | number;
    active?: boolean;
    status?: string;

    // Fiscal Data
    address?: string;
    municipalityId?: number;
    typeOrganizationId?: number;
    typeLiabilityId?: number;
    typeRegimeId?: number;
    postalZoneCode?: string;
    merchantRegistration?: string;
    dv?: string;
    countryId?: number;

    // Legacy/Extra fields
    thirdType?: number;
    type?: string;
    createdAt?: string | Date;
    updatedAt?: string | Date;
}

export class ThirdFactory {
    public static create(data: any): Third {
        return {
            id: data.id,
            usersId: data.users_id || data.usersId,
            name: data.name,
            email: data.email,
            phone: data.phone,
            identification: data.identification,
            identificationsId: data.identifications_id || data.identificationsId,

            client: data.client !== undefined ? (typeof data.client === 'number' ? data.client === 1 : !!data.client) : (data.type === 'client' || data.third_type === 1),
            provider: data.provider !== undefined ? (typeof data.provider === 'number' ? data.provider === 1 : !!data.provider) : (data.type === 'provider' || data.third_type === 2),
            other: data.other !== undefined ? (typeof data.other === 'number' ? data.other === 1 : !!data.other) : (data.type === 'other' || data.third_type === 3),
            active: data.active !== undefined ? !!data.active : (data.status === 'ACTIVE' || data.status === 'active' || data.status === undefined),
            status: data.status,

            address: data.address,
            municipalityId: data.municipality_id || data.municipalityId,
            typeOrganizationId: data.type_organization_id || data.typeOrganizationId,
            typeLiabilityId: data.type_liability_id || data.typeLiabilityId,
            typeRegimeId: data.type_regime_id || data.typeRegimeId,
            postalZoneCode: data.postal_zone_code || data.postalZoneCode,
            merchantRegistration: data.merchant_registration || data.merchantRegistration,
            dv: data.dv,
            countryId: data.country_id || data.countryId || 46,

            thirdType: data.third_type || data.thirdType,
            type: data.type,
            createdAt: data.created_at || data.createdAt,
            updatedAt: data.updated_at || data.updatedAt
        };
    }
}
